import React, { useState, useEffect } from "react";
import "../../css/Hero_New.css";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { FiArrowRight, FiShield, FiCheck } from "react-icons/fi";
import PhoneMockup from "./PhoneMockup";

export const Banner = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="banner_new_wrapper">
      {/* Immersive Background System */}
      <div className="hero_split_left"></div>
      <div className="hero_split_right"></div>
      <div className="hero_center_line"></div>

      {/* Right Side: Money Stream & Kinetic Orbs */}
      <div className="money_stream_container">
        {/* Floating Kinetic Orbs (Static) */}
        <motion.div
          className="hero_orb orb_blue"
        />
        <motion.div
          className="hero_orb orb_red"
        />

        <div className="floating_currency fc_1">₹</div>
        <div className="floating_currency fc_2">₹</div>
        <div className="floating_currency fc_3">₹</div>
        <div className="tech_flow_line" style={{ left: "10%", animationDelay: "0s" }}></div>
        <div className="tech_flow_line" style={{ left: "40%", animationDelay: "4s" }}></div>
        <div className="tech_flow_line" style={{ left: "80%", animationDelay: "2s" }}></div>
      </div>

      <div className="hero_container">
        {/* Left Side: High-Conversion Power Messaging */}
        <motion.div
          className="hero_content"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="hero_protocol_tag"
          >
            ACTOLOAN / 10 MIN LOAN
          </motion.div>

          <h1 className="hero_h1">
            GET MONEY IN <br />
            <span style={{ color: "#2889a6" }}>10 MINUTES.</span>
          </h1>

          <p className="hero_sub">
            Freedom for life. Get up to <span style={{ color: "#fff", fontWeight: "800" }}>₹1,00,000</span> in just 10 minutes. <br />
            No paperwork, no hidden fees.
          </p>

          <div className="hero_feature_pills">
            {[
              { icon: <FiCheck />, text: "100% Digital" },
              { icon: <FiCheck />, text: "10 Min Approval" },
              { icon: <FiCheck />, text: "Low CIBIL" },
              { icon: <FiCheck />, text: "Zero Collateral" },
              { icon: <FiCheck />, text: "Minimum Documentation" },
            ].map((item, idx) => (
              <div key={idx} className="feature_pill_item">
                <span style={{ color: "#2889a6", display: "flex", alignItems: "center" }}>{item.icon}</span>
                <span>{item.text}</span>
              </div>
            ))}
          </div>

          <div className="hero_action_wrap">
            <Link to="/apply-now" style={{ textDecoration: "none", display: "inline-block", width: "100%" }}>
              <motion.div
                className="hero_btn_split"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                <span>Get Your Loan Now</span> <FiArrowRight style={{ marginLeft: "10px", flexShrink: 0 }} />
              </motion.div>
            </Link>
          </div>
        </motion.div>

        {/* Right Side: Interactive Phone Mockup */}
        <div className="hero_visual_interaction">
          <PhoneMockup />
        </div>
      </div>
    </div>
  );
};

export default Banner;
